import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  functionDelete (params) {
    return axios.post(global.BASE_ACL + '/function/deleteFunctionByCode', params)
  },
  functionInsert (params) {
    return axios.post(global.BASE_ACL + '/function/insertFunction', params)
  },
  functionFindWhenUpdate (params) {
    return axios.post(global.BASE_ACL + '/function/findWhenUpdate', params)
  },
  functionUpdate (params) {
    return axios.post(global.BASE_ACL + '/function/updateFunction', params)
  },
  functionfindBySystemId () {
    return axios.post(global.BASE_ACL + '/function/findFunctionSelect')
  }
}



// WEBPACK FOOTER //
// ./src/request/syssetting/functionList.js